var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudioPauseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69662",
    "data-name": "Group 69662",
    transform: "translate(21646.777 19146)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10508",
    "data-name": "Ellipse 10508",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-21646.777 -19146)",
    fill: "#294252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69661",
    "data-name": "Group 69661",
    transform: "translate(3.256 -40.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19219",
    "data-name": "Rectangle 19219",
    width: 5,
    height: 16,
    transform: "translate(-21638 -19093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19220",
    "data-name": "Rectangle 19220",
    width: 5,
    height: 16,
    transform: "translate(-21627.066 -19093)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioPauseBlue);
export default __webpack_public_path__ + "static/media/icon-audio-pause-blue.4db020cd8fd31551a7a70a5b9dc5b63a.svg";
export { ForwardRef as ReactComponent };